import { useEffect, useRef } from "react";
import { CheckboxGroupInput, required, useRecordContext } from "react-admin";
import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export const CONTRACTS_SOURCE = "contractIds";

export const getContractIds = (contracts = []) => contracts.map(contract => contract.contractNumber);

const ContractOptionLabel = () => {
  const contract = useRecordContext();
  if (!contract) return null;

  return (
    <Box sx={{ py: 0.5 }}>
      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        Договор № {contract.contractNumber}
      </Typography>
      {contract.facultyName && (
        <Typography variant="body2" color="text.secondary">
          Факултет: {contract.facultyName}
        </Typography>
      )}
      {contract.positionName && (
        <Typography variant="body2" color="text.secondary">
          Длъжност: {contract.positionName}
        </Typography>
      )}
    </Box>
  );
};

const ContractsSelection = ({ contracts = [], isLoading, hasError }) => {
  const { setValue, getValues } = useFormContext();
  const isInitialisedRef = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    const allIds = getContractIds(contracts);
    if (!allIds.length) {
      setValue(CONTRACTS_SOURCE, []);
      return;
    }

    const preserved = isInitialisedRef.current
      ? []
      : (getValues(CONTRACTS_SOURCE) ?? []).filter(id => allIds.includes(id));

    setValue(CONTRACTS_SOURCE, preserved.length ? preserved : allIds);
    isInitialisedRef.current = true;
  }, [contracts, isLoading, setValue, getValues]);

  if (hasError) {
    return (
      <Typography variant="caption" color="error">
        Възникна проблем с извличането на работните договори
      </Typography>
    );
  }

  if (isLoading || !contracts.length) return null;

  return (
    <CheckboxGroupInput
      label="Избор на трудови договори"
      source={CONTRACTS_SOURCE}
      choices={contracts}
      optionValue="contractNumber"
      optionText={<ContractOptionLabel />}
      row={false}
      validate={required("Изберете поне един трудов договор")}
      sx={{
        "& .RaCheckboxGroupInput-label": { fontSize: 22, color: "primary.main", mb: 1, px: 2 },
        "& .MuiFormControlLabel-root": { alignItems: "flex-start" },
      }}
    />
  );
};

export default ContractsSelection;
